export class Documento {

  public uuid: string;
  public titolo: string;
  public descrizione: string;
  public uuid_allegato: string;
  public data_pubblicazione: Date;
  public ora_pubblicazione: Date;
  public tipologia: string;
  public anno: number;
  public lang: string;
  public tipo_allegato: string;
  constructor() {
  }
}
